import React, { Component } from 'react'
import PropTypes from 'prop-types'
import I18n, { Translate } from 'i18n'
import { ESC } from 'constants/keyboardKeys'
import './style.css'


export default class Item extends Component {
    static propTypes = {
        editItem: PropTypes.func.isRequired,
        deleteItem: PropTypes.func.isRequired,
        onItemEditing: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isEditing: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        note: PropTypes.string
    }

    static defaultProps = {
        note: ''
    }

    constructor(props) {
        super(props)

        this.initialState = {
            name: this.props.name,
            note: this.props.note
        }

        this.state = {
            ...this.initialState
        }
    }

    componentDidMount(){
        document.addEventListener('keydown', this.handleKeyPress)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.name !== this.props.name ||
            nextProps.note !== this.props.note) {
            this.initialState = {
                ...this.initialState,
                name: nextProps.name,
                note: nextProps.note
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.inputName &&
            this.props.isEditing && !prevProps.isEditing) {
            this.inputName.focus()
            this.inputName.select()
        }
    }

    componentWillUnmount(){
        document.removeEventListener('keydown', this.handleKeyPress)
    }

    handleKeyPress = (e) => {
        if(this.props.isEditing && e.keyCode === ESC) {
            this.handleCancel()
        }
    }

    handleValueChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleDelete = (e) => {
        e.preventDefault()
        this.props.deleteItem(this.props.id)
    }

    handleCancel = () => {
        this.toggleEditMode(false)
        this.setState(this.initialState)
    }

    handleEdit = () => {
        this.props.editItem(this.props.id, {
            name: this.state.name,
            note: this.state.note
        })

        this.toggleEditMode(false)
    }

    toggleEditMode = (isEditing) => {
        this.props.onItemEditing(isEditing ? this.props.id : null)
    }

    renderItem = () => (
        <li className='item'>
            <p onClick={() => this.toggleEditMode(true)} className='item__name'>{this.props.name}</p>
            <a href='/' onClick={this.handleDelete} className='item__delete icon icon-delete'><span><Translate value='delete' /></span></a>
        </li>
    )

    renderForm = () => (
        <li className='item-form' onClick={() => {}}>
            <form onSubmit={this.handleEdit}>
                <div className='item-form__input-wrapper item-form__input-wrapper_name'>
                    <input
                        ref={element => this.inputName = element}
                        className='item-form__input'
                        type='text'
                        name='name'
                        onChange={this.handleValueChange}
                        placeholder={I18n.t('name')}
                        value={this.state.name}
                    />
                    <div className='item-form__controls'>
                        <a onClick={this.handleEdit} className='item__edit icon icon-round-check'><span><Translate value='saveEdits' /></span></a>
                        <a onClick={this.handleCancel} className='item__cancel icon icon-delete'><span><Translate value='cancel' /></span></a>
                    </div>
                </div>
                <div className='item-form-fields'>
                    <div className='item-form__input-wrapper'>
                        <input
                            className='item-form__input'
                            type='text'
                            name='note'
                            onChange={this.handleValueChange}
                            placeholder={I18n.t('note')}
                            value={this.state.note}
                        />
                    </div>
                </div>
                <input type="submit" className='hidden' />
            </form>
        </li>
    )

    render() {
        return this.props.isEditing
            ? this.renderForm()
            : this.renderItem()
    }
}
